import React from 'react'
import { t, Trans, Plural } from '@lingui/macro'


import { typePaginationDashboardObject } from '../DashboardContentTable/PaginationDashboard/PaginationDashboard';

import { DCategoriesClassificationActions } from './actions';
import { DataTableDashboard } from '../DashboardContentTable/DataTableDashboard';
import { TableBody, TableHeader } from './tableData';
import { PopupPanelDashboard } from '../DashboardContentTable/PopupPanelDashboard';
import { PopupEdit } from './popupContents/popupEdit';
import { PopupAdd } from './popupContents/popupAdd';
import { ConfirmDialogDashboard } from '../DashboardContentTable/ConfirmDialogDashboard';
import { DashboardContentPage } from '../DashboardContentTable';
import { IdCategoriesStateDataItem } from 'model/dashboardCategories/dCategoriesReducer';
import { typeDataCategoriesBulkActions, typeDataCategoriesRowActions } from './index';
import { FiltersDashboard } from '../DashboardContentTable/FiltersDashboard';

import { InputSearch } from '../../../UI/InputSearch/InputSearch';
import { DCategoriesFilters } from './filters';

export type typeViewDataCategories = {
    variant?: string
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>

    openFilterBar: boolean
    setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>

    openPopupAdd: boolean
    setOpenPopupAdd: React.Dispatch<React.SetStateAction<boolean>>

    openPopupEdit: boolean
    setOpenPopupEdit: React.Dispatch<React.SetStateAction<boolean>>

    openDeleteDialog: boolean
    setOpenDeleteDialog: React.Dispatch<React.SetStateAction<boolean>>
    onDeleteConfirmHandler: () => void
    onDeleteCancelHandler: () => void

    openBulkDeleteDialog: boolean
    setBulkOpenDeleteDialog: React.Dispatch<React.SetStateAction<boolean>>
    onBulkDeleteConfirmHandler: () => void
    onBulkDeleteCancelHandler: () => void
    deleteCount: number

    openRecoverDialog: boolean
    setOpenRecoverDialog: React.Dispatch<React.SetStateAction<boolean>>
    onRecoverConfirmHandler: () => void
    onRecoverCancelHandler: () => void

    openBulkRecoverDialog: boolean
    setBulkOpenRecoverDialog: React.Dispatch<React.SetStateAction<boolean>>
    onBulkRecoverConfirmHandler: () => void
    onBulkRecoverCancelHandler: () => void
    recoverCount: number

    searchValue: string
    onChangeSearchValue: (e: ( React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement> )) => void
    onEnterSearch: () => void
    onClearSearch: () => void

    rowsActions: typeDataCategoriesRowActions
    bulkActions: typeDataCategoriesBulkActions

    // onAllClickExport:() => void
    //onSelectedClick: () => void

    currentItem: IdCategoriesStateDataItem | undefined
    pagination?: typePaginationDashboardObject
    isActiveFilters: boolean
    setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>
}

export const ViewDataCategories: React.FC<typeViewDataCategories> = (
    {
        variant,
        setSidebarOpen,
        openFilterBar,
        setOpenFilterBar,
        openPopupAdd,
        setOpenPopupAdd,
        openPopupEdit,
        setOpenPopupEdit,
        openDeleteDialog,
        setOpenDeleteDialog,
        onDeleteConfirmHandler,
        onDeleteCancelHandler,
        openBulkDeleteDialog,
        setBulkOpenDeleteDialog,
        onBulkDeleteConfirmHandler,
        onBulkDeleteCancelHandler,
        deleteCount,
        openRecoverDialog,
        setOpenRecoverDialog,
        onRecoverConfirmHandler,
        onRecoverCancelHandler,
        openBulkRecoverDialog,
        onBulkRecoverCancelHandler,
        onBulkRecoverConfirmHandler,
        setBulkOpenRecoverDialog,
        recoverCount,


        searchValue,
        onChangeSearchValue,
        onClearSearch,
        onEnterSearch,
        bulkActions,
        rowsActions,
        currentItem,

        pagination,
        isActiveFilters,
        setIsActiveFilters
    }) => {

    return (
        <DashboardContentPage
            headerTitle={ <Trans>Categories</Trans> }
            setSidebarOpen={ setSidebarOpen }
            actions={ <DCategoriesClassificationActions onClickAdd={ () => setOpenPopupAdd(true) }/> }
        >
            {/* Filter bar */ }
            <FiltersDashboard
                variant={ variant }
                filters={ {
                    filtersForm: <DCategoriesFilters setOpenFilterBar={ setOpenFilterBar }
                                                     setIsActiveFilters={ setIsActiveFilters }/>,
                    openFilterBar: openFilterBar,
                    setOpenFilterBar: setOpenFilterBar,
                } }
                searchBar={ <InputSearch
                    id="zReportsSearch"
                    name="zReportsSearch"
                    placeholder={ t`Search by category name` }
                    value={ searchValue }
                    onChange={ onChangeSearchValue }
                    onClear={ onClearSearch }
                    onKeyEnterDown={ onEnterSearch }
                /> }
                isActiveFilters={ isActiveFilters }
            />

            {/* Table data */ }
            <DataTableDashboard
                tableHeader={ <TableHeader bulkActions={ bulkActions }/> }
                tableBody={ <TableBody rowsActions={ rowsActions }/> }
                pagination={ pagination }
            />

            {/* Popup Edit item dialog */ }
            <PopupPanelDashboard
                title={ <Trans>Edit category</Trans> }
                openPopup={ openPopupEdit }
                setOpenPopup={ setOpenPopupEdit }
            >
                <PopupEdit setOpenPopup={ setOpenPopupEdit }/>
            </PopupPanelDashboard>

            {/* Popup Add item dialog */ }
            <PopupPanelDashboard
                title={ <Trans>Add category</Trans> }
                openPopup={ openPopupAdd }
                setOpenPopup={ setOpenPopupAdd }
            >
                <PopupAdd setOpenPopup={ setOpenPopupAdd }/>
            </PopupPanelDashboard>

            {/* Item Delete dialog */ }
            <ConfirmDialogDashboard
                type="error"
                title={ <Trans>Delete category</Trans> }
                message={ <Trans>Are you sure you want to delete the category <b>{ currentItem?.name }</b>?<br/>
                    Products from this category will be marked as not having a category</Trans> }
                primaryButton={ { title: <Trans>Delete</Trans>, action: onDeleteConfirmHandler } }
                secondaryButton={ { title: <Trans>Cancel</Trans>, action: onDeleteCancelHandler } }
                openDialog={ openDeleteDialog }
                setOpenDialog={ setOpenDeleteDialog }
            />

            {/* Item Recover dialog */ }
            <ConfirmDialogDashboard
                variant={ variant }
                type="info"
                title={ <Trans>Recover category</Trans> }
                message={ <Trans>Do you really want recover category <b>{ currentItem?.name }</b>?</Trans> }
                primaryButton={ { title: <Trans>Recover</Trans>, action: onRecoverConfirmHandler } }
                secondaryButton={ { title: <Trans>Cancel</Trans>, action: onRecoverCancelHandler } }
                openDialog={ openRecoverDialog }
                setOpenDialog={ setOpenRecoverDialog }
            />

            {/* Bulk Delete dialog */ }
            <ConfirmDialogDashboard
                variant={ variant }
                type="error"
                title={ <Trans>Delete categories</Trans> }
                message={ <>
                    <Trans>Do you really want delete</Trans> <b>{ deleteCount }</b> <Plural value={ deleteCount }
                                                                                            one={ 'category' }
                                                                                            other={ 'categories' }/>?
                    <br/>
                    <Trans>Products from this categories will be marked as not having a category</Trans>
                </>
                }
                primaryButton={ { title: <Trans>Delete</Trans>, action: onBulkDeleteConfirmHandler } }
                secondaryButton={ { title: <Trans>Cancel</Trans>, action: onBulkDeleteCancelHandler } }
                openDialog={ openBulkDeleteDialog }
                setOpenDialog={ setBulkOpenDeleteDialog }
            />
            {/* Bulk Recover  dialog */ }
            <ConfirmDialogDashboard
                variant={ variant }
                type="info"
                title={ <Trans>Recover categories</Trans> }
                message={ <>
                    <Trans>Do you really want recover </Trans> <b>{ recoverCount }</b> <Plural value={ deleteCount }
                                                                                               one={ 'category' }
                                                                                               other={ 'categories' }/>?
                    <br/>
                </>
                }
                primaryButton={ { title: <Trans>Recover</Trans>, action: onBulkRecoverConfirmHandler } }
                secondaryButton={ { title: <Trans>Cancel</Trans>, action: onBulkRecoverCancelHandler } }
                openDialog={ openBulkRecoverDialog }
                setOpenDialog={ setBulkOpenRecoverDialog }
            />
        </DashboardContentPage>
    )
}
